module.exports = "<button ng-click=\"buttonFn()\" class=\"spinner-button btn\"  ng-attr-id=\"{{ buttonId }}\"\n        ng-class=\"{'btn-primary': isPrimaryBtn === true, 'btn-default': isPrimaryBtn === false, 'clicked': displaySpinner === true}\" ng-disabled=\"isDisabled\">\n    <span ng-bind=\"buttonText\" ng-if=\"displaySpinner === false\"></span>\n    <div class=\"spinner-button-container\">\n        <div ra-spinner name=\"btnSpinner\" show=\"displaySpinner === true\" template=\"indeterminateSpinnerSmall\" register=\"false\"></div>\n    </div>\n</button>";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/controls/spinnerButton/spinnerButton.html
// module id = 958
// module chunks = 1